import { z } from 'zod'
import {
  MAX_NAME_OR_SURNAME_LENGTH,
  MAX_USERNAME_LENGTH
} from '../../../../const/inputs'

export const signUpSchema = z.object({
  username: z
    .string()
    .trim()
    .min(1, 'Wymagane pole')
    .max(
      MAX_USERNAME_LENGTH,
      `maksymalna ilość znaków to ${MAX_USERNAME_LENGTH}`
    ),
  password: z.string().trim().min(1, 'Wymagane pole'),
  passwordRepeated: z.string().trim().min(1, 'Wymagane pole'),
  name: z
    .string()
    .trim()
    .min(1, 'Wymagane pole')
    .max(
      MAX_NAME_OR_SURNAME_LENGTH,
      `maksymalna ilość znaków to ${MAX_NAME_OR_SURNAME_LENGTH}`
    ),
  surname: z
    .string()
    .trim()
    .min(1, 'Wymagane pole')
    .max(
      MAX_NAME_OR_SURNAME_LENGTH,
      `maksymalna ilość znaków to ${MAX_NAME_OR_SURNAME_LENGTH}`
    ),
  email: z.string().min(5, 'Za krótki email').email('Niepoprawny email')
})

export type SignUpProps = z.infer<typeof signUpSchema>
